import { render, staticRenderFns } from "./bizTypeSelect.vue?vue&type=template&id=00a8586a&scoped=true"
import script from "./bizTypeSelect.vue?vue&type=script&lang=js"
export * from "./bizTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./bizTypeSelect.vue?vue&type=style&index=0&id=00a8586a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8586a",
  null
  
)

export default component.exports